import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'

export const GotoDetailMenuItem = () => {
  // const { invoice } = useContextMenuContext()
  // const history = useHistory()
  // const code = invoice?.code
  // const id = invoice?._id

  const onClick = async () => {
    //history.push(routesDef.InvoicesDetailPage.altPath({ id, code }))
  }

  return <BusyButton bsSize="sm" bsStyle={'info'} onClick={onClick} icon="sign-in" title="Go to invoice detail" />
}
